import React from "react";
import { Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { motion } from "framer-motion";
import { springVariants, springViewport } from '../utils/framerVariants';

const Bookmarks = ({ data, location }) => {
  const isGerman = typeof window !== 'undefined' && window.location.pathname.includes('/de/');
  const articlesValue = data.articles || [];

  const isArticleEmpty = (value) => !value || value === '';

  // Calculate the column count based on the number of entries
   const entryCount = articlesValue.length
   let columnCount = "grid-cols-3"; // Default to 3 columns

   if (entryCount === 1) {
     columnCount = "grid-cols-2";
   } else if (entryCount === 2) {
     columnCount = "grid-cols-2";
   }

  const renderArticleCard = (entry, index) => {
    const isVideo = entry.videocover?.mime?.startsWith("video");

    return (
      <div className="col-span-1" key={entry.id}>
        <motion.div
          variants={springVariants}
          initial="invisible"
          whileInView="visible"
          viewport={springViewport}
          className="articleCard"
        >
          <Link to={`/${isGerman ? 'de/' : ''}${entry.slug}`} title={entry.title}>
            {isVideo ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: `<video class="allianz-player aspect-foundation object-cover h-full w-full" playsinline autoplay loop muted><source src="${entry.videocover.file.url}" type="video/mp4" /></video>`
                }}
              />
            ) : (
              <GatsbyImage
                className="aspect-foundation"
                image={getImage(entry.cover?.file)}
                alt={entry.cover?.alternativeText || "Alternative Text missing"}
              />
            )}
          </Link>

          {entry.tags && entry.tags.length > 0 && (
            <div className="flex gap-x-4 gap-y-1 mt-6 pr-24 md:pr-56 flex-wrap">
              {entry.tags.map((tag, i) => (
                <Link
                  to={`/${isGerman ? 'de/' : ''}${tag.slug}`}
                  title={tag.name}
                  key={i}
                  className="tags font-semibold lowercase">
                  <span className="text-tags tracking-text leading-text font-semibold">{tag.name}</span>
                </Link>
              ))}
            </div>
          )}


          <Link to={`/${isGerman ? 'de/' : ''}${entry.slug}`} title={entry.title} className="xl:max-w-xl 2xl:max-w-2xl block max-w-none md:max-w-md lg:max-w-lg">
            <h2 className="pr-12 font-bold mt-6 mb-4">{entry.title}</h2>
            <p className="pr-12">{entry.description}</p>
          </Link>
        </motion.div>
      </div>
    );
  };

  return (
    <div className="container mx-auto max-w-none mb-16 md:mb-24 lg:mb-32 xl:mb-48 px-4 md:px-8">
      <div className={`grid md:${columnCount} gap-x-8 gap-y-16`}>
        {isGerman ? (
          <>
            {articlesValue.map((entry) =>
              isArticleEmpty(entry) ? null : renderArticleCard(entry)
            )}
          </>
        ) : (
          <>
            {articlesValue.map((entry) =>
              isArticleEmpty(entry) ? null : renderArticleCard(entry)
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Bookmarks;
